import React, { useEffect, useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { getRequest } from '../../globalhelper/helper'
import _ from 'lodash'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  IconButton
} from '@mui/material'
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import LastPageIcon from '@mui/icons-material/LastPage'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment/moment'

function TablePaginationActions (props) {
  const theme = useTheme()
  const { count, page, rowsPerPage, onPageChange } = props
  const [previousCount, setPreviousCount] = useState(count)

  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0)
    }
    setPreviousCount(count)
  }, [count, page, onPageChange, previousCount])

  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0)
  }

  const handleBackButtonClick = event => {
    onPageChange(event, page - 1)
  }

  const handleNextButtonClick = event => {
    onPageChange(event, page + 1)
  }

  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label='first page'
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label='previous page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='next page'
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='last page'
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  )
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
}

function DraftDocument (props) {
  let [companyDetails, setCompanyDetails] = useState([])
  let [company, setCompany] = useState('')
  let [tableData, setTabledata] = useState([])
  let [displayData, setDisplayData] = useState([])
  let [period, setPeriod] = useState(moment())
  let [DocType, setDocType] = useState(null)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        console.log(response.res.data)
        const responseData = _.sortBy(response.res.data, 'orgname')
        const arr = responseData.map(item => ({
          label: item.orgname,
          value: item.orgid
        }))
        if (arr?.length === 1) {
          setCompany(arr[0])
        }
        setCompanyDetails(arr)
      })
      .catch(err => console.log(err))
  }, [])

  const handleSubmit = async () => {
    try {
      let response = await getRequest(
        `api/vr2/getDraftDocuments?company=${company?.value}&screenName=${props.screenName}`
      )
      if (response.res.status === 'success') {
        setTabledata(JSON.parse(response.res.data))
        setDisplayData(JSON.parse(response.res.data))
      }
    } catch (err) {
      console.log(err)
    }
  }

  const openDraft = async data => {
    try {
      localStorage.setItem(
        'api',
        `api/vr2/getDraftDocument?orgId=${company?.value}&screenName=${data.DocumentName}&ReferenceName=${data['name']}`
      )
      window.open(
        `/Dynamic_Forms?token=${data.DocumentName}&action=draft&orgId=${company?.value}&refName=${data['name']}`,
        '_blank'
      )
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (!period) return

    // if your period is '2025-10'
    const startDate = moment(period, 'YYYY-MM').startOf('month')
    const endDate = moment(period, 'YYYY-MM').endOf('month')

    const filtered = tableData.filter(item => {
      // parse with correct format (DD/MM/YYYY)
      const itemDate = moment(item.lastModified, 'DD/MM/YYYY')
      return (
        itemDate.isSameOrAfter(startDate) && itemDate.isSameOrBefore(endDate)
      )
    })

    console.log(
      'start',
      startDate.format(),
      'end',
      endDate.format(),
      'filtered',
      filtered
    )

    setDisplayData(filtered)
  }, [period, tableData])

  useEffect(() => {
    if (!DocType) {
      setDisplayData(tableData)
      return
    }
    const filtered = tableData?.filter(item => item.DocumentName === DocType)
    setDisplayData(filtered)
  }, [DocType])
  return (
    <>
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel3-content'
          id='panel3-header'
        >
          <Typography variant='h6'>Search {props.screenName} Drafts</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={3}>
            <Grid item xs={1} sm={2} md={4}>
              <Autocomplete
                options={companyDetails || []}
                getOptionLabel={option => option?.label || ''}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value || ''
                }
                value={company || ''}
                onChange={(e, newValue) => setCompany(newValue)}
                renderInput={params => (
                  <TextField
                    name='orgname'
                    {...params}
                    label='Organization Name'
                    variant='outlined'
                    size='small'
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item>
              <Button
                onClick={handleSubmit}
                variant='contained'
                color='primary'
                disabled={!company}
              >
                submit
              </Button>
              &nbsp;
              <Button
                onClick={props.onBack}
                variant='contained'
                color='warning'
              >
                Back
              </Button>
            </Grid>
          </Grid>
          <Typography variant='h6' mt={2} mb={1}>
            Filter
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={1} sm={2} md={4}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label='Period'
                  value={period}
                  views={['month', 'year']}
                  onChange={newValue => {
                    setPeriod(newValue)
                  }}
                  renderInput={params => (
                    <TextField fullWidth size='small' {...params} />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            {(props.screenName === 'ItemMaster' ||
              props.screenName === 'VendorMaster') && (
              <Grid item xs={1} sm={2} md={4}>
                <Autocomplete
                  options={
                    (props.screenName === 'ItemMaster' && [
                      'ItemPreferences',
                      'ItemMaster'
                    ]) ||
                    (props.screenName === 'VendorMaster' && [
                      'VendorPreferences',
                      'VendorMaster'
                    ])
                  }
                  value={DocType || ''}
                  onChange={(e, newValue) => setDocType(newValue)}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label='Document Name'
                      variant='outlined'
                      size='small'
                      fullWidth
                    />
                  )}
                />
              </Grid>
            )}
          </Grid>
        </AccordionDetails>
      </Accordion>
      {(tableData.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {Object.keys(tableData[0]).map(key => (
                  <TableCell>{key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(displayData.length > 0 &&
                (rowsPerPage > 0
                  ? displayData.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : displayData
                ).map(data => (
                  <TableRow>
                    {Object.keys(tableData[0]).map(key => (
                      <TableCell>
                        {(key === 'name' && (
                          <Button
                            variant='text'
                            color='primary'
                            onClick={() => openDraft(data)}
                          >
                            {data[key]}
                          </Button>
                        )) ||
                          data[key]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))) || (
                <TableRow>
                  <TableCell colSpan={Object.keys(tableData[0]).length}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%'
                      }}
                    >
                      <Alert severity='error' variant='outlined'>
                        No matching records found. Please adjust your search criteria.
                      </Alert>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  sx={{
                    position: 'sticky',
                    bottom: 0,
                    left: 0,
                    backgroundColor: 'white',
                    zIndex: 2
                  }}
                  rowsPerPageOptions={[5, 10, 20, { label: 'All', value: -1 }]}
                  colSpan={3}
                  count={displayData.length}
                  rowsPerPage={rowsPerPage}
                  page={Math.min(
                    page,
                    Math.max(0, Math.ceil(displayData.length / rowsPerPage) - 1)
                  )}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      )) || (
        <Box sx={{ margin: 'auto' }}>
          <Alert severity='warning'>
            <AlertTitle>No Data Found</AlertTitle>
            There is no data to display at the moment.
          </Alert>
        </Box>
      )}
    </>
  )
}

export default DraftDocument
